export default () => {
  const s = document.createElement('script');
  s.type = 'text/javascript';
  s.src = 'scripts/initSentry.js';
  document.body.appendChild(s);
};
